var render = function render(){var _vm=this,_c=_vm._self._c;return _c('select-search-field',{attrs:{"disabled":_vm.disabled,"list":_vm.cleanedList,"is-multiple":_vm.isMultiple,"value":_vm.value,"name":"value"},on:{"change":_vm.change}})
}
var staticRenderFns = []

export { render, staticRenderFns }